import { CHUNK_SIZE } from "./constants";

export type Vec3 = {
  readonly x: number;
  readonly y: number;
  readonly z: number;
};

export type ChunkCoord = {
  readonly cx: number;
  readonly cy: number;
  readonly cz: number;
};

export function worldToChunk(wx: number, wy: number, wz: number): ChunkCoord {
  return {
    cx: Math.floor(wx / CHUNK_SIZE),
    cy: Math.floor(wy / CHUNK_SIZE),
    cz: Math.floor(wz / CHUNK_SIZE),
  };
}

export function worldToLocal(wx: number, wy: number, wz: number): Vec3 {
  return {
    x: ((wx % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE,
    y: ((wy % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE,
    z: ((wz % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE,
  };
}

export function chunkToWorld(cx: number, cy: number, cz: number): Vec3 {
  return {
    x: cx * CHUNK_SIZE,
    y: cy * CHUNK_SIZE,
    z: cz * CHUNK_SIZE,
  };
}

export function vec3(x: number, y: number, z: number): Vec3 {
  return { x, y, z };
}

export function addVec3(a: Vec3, b: Vec3): Vec3 {
  return { x: a.x + b.x, y: a.y + b.y, z: a.z + b.z };
}

export function scaleVec3(v: Vec3, s: number): Vec3 {
  return { x: v.x * s, y: v.y * s, z: v.z * s };
}

export function distanceVec3(a: Vec3, b: Vec3): number {
  const dx = a.x - b.x;
  const dy = a.y - b.y;
  const dz = a.z - b.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}

export function distanceXZ(a: Vec3, b: Vec3): number {
  const dx = a.x - b.x;
  const dz = a.z - b.z;
  return Math.sqrt(dx * dx + dz * dz);
}
